import { render, staticRenderFns } from "./ConformidadeTecnicaForm.vue?vue&type=template&id=188a55c8"
import script from "./ConformidadeTecnicaForm.vue?vue&type=script&lang=js"
export * from "./ConformidadeTecnicaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports